jQuery(function ($) {

  // get focusable elements inside modal
  function getFocusableElements(container) {
    return container
      .find(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      )
      .filter(":visible");
  }

  //------------ LOGIN MODAL -------------------------------------------------------

  const modals = $(".modal-login");
  const triggers = $(".login-trigger");
  const closeButtons = $(".close-login-button");

  let lastTrigger = null; // store the button that opened the modal

  function trapFocus(e, modal) {
    const focusableEls = getFocusableElements(modal);
    if (!focusableEls.length) return;

    const firstEl = focusableEls[0];
    const lastEl = focusableEls[focusableEls.length - 1];

    if (e.key === "Tab") {
      if (e.shiftKey) {
        // shift + tab
        if (document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        }
      } else {
        // tab
        if (document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }
    }

    if (e.key === "Escape") {
      closeDialog(modal);
    }
  }

  function showDialog(modal) {
    modal.addClass("show-modal").removeClass("invisible opacity-0");
    $("body").css("overflow", "hidden");

    const focusableEls = getFocusableElements(modal);
    if (focusableEls.length) {
      focusableEls[0].focus(); // focus first input/button
    }

    $(document).on("keydown.trap", (e) => trapFocus(e, modal));
  }

  function closeDialog(modal) {
    modal.removeClass("show-modal").addClass("invisible opacity-0");
    $("body").css("overflow", "auto");

    if (lastTrigger) {
      lastTrigger.focus(); // return focus to trigger
    }

    $(document).off("keydown.trap");
  }

  function toggleModal(modal, trigger) {
    if (modal.hasClass("show-modal")) {
      closeDialog(modal);
    } else {

      if (modals.hasClass("show-modal")) {
        closeDialog(modals);
      }

      if ($(".modal-register").hasClass("show-modal")) {
        closeDialogRegister($(".modal-register"));
      }

      lastTrigger = trigger; // remember which button opened it
      showDialog(modal);
    }
  }

  // Open triggers
  triggers.on("click", function (e) {
    e.preventDefault();
    const modal = modals.first(); // adjust if multiple modals
    toggleModal(modal, $(this));
  });

  // Close buttons
  closeButtons.on("click", function (e) {
    e.preventDefault();
    const modal = $(this).closest(".modal-login");
    closeDialog(modal);
  });


  //------------ FORGET PASSWORD -------------------------------------------------------


  const modalForget = $(".modal-forget");
  const triggersForget = $(".forget-trigger");
  const closeButtonForget = $(".close-forget-button");

  let lastTriggerForget = null; // remember the button/link that opened modal

  function trapFocusForget(e, modal) {
    const focusableEls = getFocusableElements(modal);
    if (!focusableEls.length) return;

    const firstEl = focusableEls[0];
    const lastEl = focusableEls[focusableEls.length - 1];

    if (e.key === "Tab") {
      if (e.shiftKey) {
        // shift + tab
        if (document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        }
      } else {
        // tab
        if (document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }
    }

    if (e.key === "Escape") {
      closeDialogForget(modal);
    }
  }

  function showDialogForget(modal) {
    modal.addClass("show-modal").removeClass("invisible opacity-0");
    $("body").css("overflow", "hidden");

    const focusableEls = getFocusableElements(modal);
    if (focusableEls.length) {
      focusableEls[0].focus(); // focus first input/button
    }

    $(document).on("keydown.trapForget", (e) => trapFocusForget(e, modal));
  }

  function closeDialogForget(modal) {
    modal.removeClass("show-modal").addClass("invisible opacity-0");
    $("body").css("overflow", "auto");

    if (lastTriggerForget) {
      lastTriggerForget.focus(); // return focus to trigger
    }

    $(document).off("keydown.trapForget");
  }

  function toggleModalForget(modal, trigger) {
    if (modal.hasClass("show-modal")) {
      closeDialogForget(modal); // close forget modal
    } else {
      // close login modal if it's open
      if (modals.hasClass("show-modal")) {
        closeDialog(modals);
      }

      lastTriggerForget = trigger;
      showDialogForget(modal); // then open forget modal
    }
  }

  // Open triggers
  triggersForget.on("click", function (e) {
    e.preventDefault();
    toggleModalForget(modalForget, $(this));
  });

  // Close buttons
  closeButtonForget.on("click", function (e) {
    e.preventDefault();
    closeDialogForget($(this).closest(".modal-forget"));
  });

  //------------ REGISTER MODAL -------------------------------------------------------

  const modalRegister = $(".modal-register");
  const triggersRegister = $(".register-trigger");
  const closeButtonRegister = $(".close-register-button");

  let lastTriggerRegister = null;

  function trapFocusRegister(e, modal) {
    const focusableEls = getFocusableElements(modal);
    if (!focusableEls.length) return;

    const firstEl = focusableEls[0];
    const lastEl = focusableEls[focusableEls.length - 1];

    if (e.key === "Tab") {
      if (e.shiftKey) {
        // shift + tab
        if (document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        }
      } else {
        // tab
        if (document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }
    }

    if (e.key === "Escape") {
      closeDialogRegister(modal);
    }
  }

  function showDialogRegister(modal) {
    modal.addClass("show-modal").removeClass("invisible opacity-0");
    $("body").css("overflow", "hidden");

    const focusableEls = getFocusableElements(modal);
    if (focusableEls.length) {
      focusableEls[0].focus(); // focus first input/button
    }

    $(document).on("keydown.trapRegister", (e) => trapFocusRegister(e, modal));
  }

  function closeDialogRegister(modal) {
    modal.removeClass("show-modal").addClass("invisible opacity-0");
    $("body").css("overflow", "auto");

    if (lastTriggerRegister) {
      lastTriggerRegister.focus(); // return focus to trigger
    }

    $(document).off("keydown.trapRegister");
  }

  function toggleModalRegister(modal, trigger) {
    if (modal.hasClass("show-modal")) {
      closeDialogRegister(modal); // close forget modal
    } else {
      // close login modal if it's open
      if (modals.hasClass("show-modal")) {
        closeDialog(modals);
      }

      lastTriggerRegister = trigger;
      showDialogRegister(modal); // then open forget modal
    }
  }

  // Open triggers
  triggersRegister.on("click", function (e) {
    e.preventDefault();
    toggleModalRegister(modalRegister, $(this));
  });

  // Close buttons
  closeButtonRegister.on("click", function (e) {
    e.preventDefault();
    closeDialogRegister($(this).closest(".modal-register"));
  });

  //------------ RESET PASSWORD  -------------------------------------------------------

  const modalResetPassword = $("#modal-resetPassword");
  const triggersResetPassword = $("#reset-password");
  const closeButtonResetPassword = $(".close-resetPassword-button");

  let lastTriggerResetPwd = null;

  function trapFocusResetPwd(e, modal) {
    const focusableEls = getFocusableElements(modal);
    if (!focusableEls.length) return;

    const firstEl = focusableEls[0];
    const lastEl = focusableEls[focusableEls.length - 1];

    if (e.key === "Tab") {
      if (e.shiftKey) {
        // shift + tab
        if (document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        }
      } else {
        // tab
        if (document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }
    }

    if (e.key === "Escape") {
      closeDialogResetPassword(modal);
    }
  }

  function showDialogResetPassword(modal) {
    modal.addClass("show-modal");
    $("body").css("overflow", "hidden");

    const focusableEls = getFocusableElements(modal);
    if (focusableEls.length) {
      focusableEls[0].focus(); // focus first input/button
    }

    $(document).on("keydown.trapResetPwd", (e) => trapFocusResetPwd(e, modal));
  }

  function closeDialogResetPassword(modal) {
    modal.removeClass("show-modal");
    $("body").css("overflow", "auto");

    if (lastTriggerResetPwd) {
      lastTriggerResetPwd.focus(); // return focus to trigger
    }

    $(document).off("keydown.trapResetPwd");
  }

  function toggleModalResetPassword(modal, trigger) {
    if (modal.hasClass("show-modal")) {
      closeDialogResetPassword(modal);
    } else {
      lastTriggerResetPwd = trigger; // remember which button opened it
      showDialogResetPassword(modal);
    }
  }

  // Open triggers
  triggersResetPassword.on("click", function (e) {
    e.preventDefault();
    if ($('#resetPassword').hasClass('hidden')) {
      $('#resetPassword').removeClass('hidden');
      $('.reset-successful').html('');
    }
    toggleModalResetPassword(modalResetPassword, $(this));
  });

  // Close buttons
  closeButtonResetPassword.on("click", function (e) {
    e.preventDefault();
    closeDialogResetPassword($(this).closest("#modal-resetPassword"));
  });




});
